
import { computed, defineComponent, Ref, ref } from 'vue'
import PostSingle from '@/components/Post/PostSingle.vue'
import { Post } from '@/model/data-object/Post'
import AdvertPosition from '@/components/Post/AdvertPosition.vue'
import useAdvertManager from '@/composables/advert/advertManager'
import useConfiguration from '@/composables/configuration/configuration'

const { configuration } = useConfiguration()

export default defineComponent({
  name: 'PostListBranch',
  components: { AdvertPosition, PostSingle },
  emits: ['post-responded'],
  props: {
    postRoot: {
      type: Object, // todo retype to postRoot
      required: true,
    },
    showRedirectToThreadButton: {
      type: Boolean,
      default: false,
    },
    openRespondPage: {
      type: Boolean,
      default: false,
    },
    allowShowNew: {
      type: Boolean,
      default: false,
    },
    stripLongText: {
      type: Boolean,
      default: false,
    },
    disableAdvert: {
      type: Boolean,
      default: false,
    },
    level: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      collapsed: false,
      currentLevel:
        configuration.maxPostTreeDepth < this.level
          ? configuration.maxPostTreeDepth
          : this.level,
    }
  },
  async setup(props, context) {
    const isTopLevelNonRoot: Ref<boolean> = ref<boolean>(false)
    const { advertPositionsList } = useAdvertManager()

    isTopLevelNonRoot.value =
      props.postRoot.post && props.postRoot.post.parent !== null

    const postResponded = function(post: Post) {
      context.emit('post-responded', post)
    }

    const advert = computed(() => {
      if (props.postRoot.id in advertPositionsList) {
        return advertPositionsList[props.postRoot.id]
      }
    })

    return {
      isTopLevelNonRoot,
      advert,
      postResponded,
    }
  },
})
